
import { Component, Inject, ViewChild , ElementRef , OnInit} from '@angular/core';

import { Store } from '@src/store';
import { cmsActions } from '@src/store/reducers/cmsReducer';
import { DialogManagerService } from '@src/services';
import {AddOrEditActivityComponent} from '@app/shared/components/dialogs/add-or-edit-activity-dialog/add-or-edit-activity-dialog.component'
import * as _str from 'underscore.string';
import { MatSort, MatTable, MatTableDataSource } from '@angular/material';


export interface JiraCmsTable {
  Id: string;
  Name: string;
  Text: string;
}

@Component({
    selector: 'jira-cms-tasks',
    template: require('./jira-cms-tasks.component.html'),
    styles: [require('./jira-cms-tasks.component.scss')]
})

export class JiraCmsTasksComponent implements OnInit {
  public projectId:any;
  public unsubscribe:any;
  public filter:string;
  public testRes:any;
  public editMode:any;
  public selectedActivity:any;
  public tasks:any;
  public testIndex:number
  public filterDataTasks:any[];
  public displayedColumns = ['Id', 'Name', 'Text', 'Actions'];
  @ViewChild(MatSort) public sort: MatSort;
  public dataSource;

  @ViewChild(MatTable, { read: ElementRef }) private;



    constructor(private store: Store , @Inject('$stateParams') $stateParams: any , private dialogManagerService : DialogManagerService){
      this.dataSource = new MatTableDataSource<JiraCmsTable>([]);
      this.projectId = $stateParams.id
 
 

 
  }

  public ngOnInit(){
     this.getQueriesFromApi()
}

  getQueriesFromApi(){
    const data = [];
    this.editMode = this.store.getState().project.editMode
  
    this.unsubscribe = this.store.subscribe(() => {
      if (this.store.getState().cmss.tasks) {
        this.tasks = this.store.getState().cmss.tasks;
         this.tasks.forEach((item) => {
          
          item.tagsNames = item.tags ? item.tags.map(m => m.displayName).join(', ') : '';
            data.push({
              id : item.id,
              name : item.name,
              text : item.text
          }); 
      })
      this.dataSource.data = data;
      this.filterDataTasks = data
      if(this.dataSource.data.length > 0){
        this.unsubscribe();
      }
    }

  })
 }


  

  addOrEditActivity(edit) {
       
    const onConfirm = (data) => {
        const projectId = this.projectId;
        if (edit) {
            const type = cmsActions.EDIT_JIRA_QUERY_TASK
            this.store.dispatch({
                type: type,
                payload: {
                    data: {
                        
                        name: data.activity.name,
                        text: (data.activity.text) ? data.activity.text : '',
                        projectId
                    },
                    queryId: data.activity.id,
                    projectId
                }
            });  
        }
        else {
                this.store.dispatch({
                    type: cmsActions.ADD_JIRA_QUERY_TASK,
                    payload: {
                        data: {
                            name: data.activity.name,
                            text: (data.activity.text) ? data.activity.text : '',
                            projectId
                        },
                        projectId
                    },
                    callback: () => { }
                }).then(res => {
                    if (res) {
                        this.store.dispatch({ type: cmsActions.GET_ALL_JIRA_CMS_TASKS_QUERYS, payload: { projectId: this.projectId } });
                        this.getQueriesFromApi()
                    }
                })
        }
    };

    const dialogData = {
        title:  (edit) ? 'Edit Query' : 'Add New Query',
        activity: (edit) ? {...this.selectedActivity.data} : {},
        Tooltip : this.getTooltip(),
        projectId : this.projectId,
        store : this.store
    };
    this.dialogManagerService.showDialog(dialogData, onConfirm, AddOrEditActivityComponent, 'add-or-edit-activity-dialog');

}

onEditActivity(data) {
  this.selectedActivity = data;
  this.addOrEditActivity(true);
}

onRemoveActivity(data) {
  this.selectedActivity = data;
  const onConfirm = () => {
      this.store.dispatch({ type: cmsActions.DELETE_JIRA_QUERY_TASK, payload: { projectId: this.projectId, queryId: this.selectedActivity.data.id } }).then(x=> {
        if(x){
          this.getQueriesFromApi()
        }
      })
  };
  const dialogData = { title: 'Delete Query', action: 'delete', objectType: 'Query', item: data.name };
  this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
  const unSubscribe = this.store.subscribe(_ => {
      if (this.store.getState().cmss && this.store.getState().cmss.deleteJiraTask) {
          this.store.dispatch({ type: cmsActions.GET_ALL_JIRA_CMS_TASKS_QUERYS, payload: { projectId: this.projectId } });
          unSubscribe();
      }
  });
}

onTestQuery(data) {
  let localCheckTest = true;
  const unSubscribe = this.store.subscribe(_ => {
      if (this.store.getState().cmss && this.store.getState().cmss.test && localCheckTest) {
          localCheckTest = false;
          data.test = this.store.getState().cmss.test;
          this.testRes = data.test
          this.testIndex = data.index
          unSubscribe();
      }
  });
  this.store.dispatch({
      type: cmsActions.TEST_JIRA_QUERY_TASK_CONNECTION,
      payload: { projectId: this.projectId, text: data.test.text }
  });
}

filterData(filter){
  if (!this.dataSource.data || !filter) {
    this.dataSource.data = this.filterDataTasks
}
 for (const property of Object.keys(this.filterDataTasks[0])) {
    let res = this.filterDataTasks.filter(x => String(x[property]).includes(filter));
    if(res.length > 0 ){
      this.dataSource.data = res
    }
 }
}

  getTooltip()  {
    if (this.store.getState().projects.projectWithMetaData.connectedCmsProject.cmsTypeName == "JIRA") {
        return  'HELP_JQL_QUERY_TOOLTIP'
    } else if (this.store.getState().projects.projectWithMetaData.connectedCmsProject.cmsTypeName == "ServiceNow") {
        return 'HELP_SERVICE_NOW_TOOLTIP'
    }
}







}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/jiraCMSManager-ang7/jiraCmsTasks/jira-cms-tasks.component.ts